import React, { useEffect, useContext, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { BlogContext } from '../../context/BlogContext';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../style/Blog.css';
import PostCard from '../Layout/PostCard';

const MyBlogs = () => {
  const { user, userLoaded } = useContext(AuthContext);
  const { getMyBlogs } = useContext(BlogContext);
  const [myBlogs, setMyBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (userLoaded && !user) {
      navigate('/login');
    }
  }, [user, userLoaded, navigate]);

  useEffect(() => {
    const fetchMyBlogs = async () => {
      try {
        const blogs = await getMyBlogs();
        setMyBlogs(blogs);
      } catch (error) {
        // console.error("Error fetching my blogs:", error);
        setError("Failed to load your blogs. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchMyBlogs();
    }
  }, [user, getMyBlogs]);

  if (!userLoaded) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="dark" /></div>;
  }

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="dark" /></div>;
  }

  if (error) {
    return <div className="text-center mt-5"><Alert variant="danger">{error}</Alert></div>;
  }

  const filteredBlogs = [...myBlogs]
  .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
  .filter(blog =>
    blog.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <Container className="mt-5 mb-4">
      <div className="retro-window">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="text-center mb-4">My Posts</h1>
        <div className="mb-3 text-center">
        <input
  type="text"
  className="form-control w-75 mx-auto"
  placeholder="Search by title..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>

</div>

      </div>
      <Row className="justify-content-center g-4">
        {filteredBlogs.length === 0 ? (
          <Col xs={12} className="text-center">
            <p>No posts yet.</p>
          </Col>
        ) : (
          filteredBlogs.map(blog => (

            <Col key={blog._id} xs={12} md={6} lg={4}>
              <PostCard post={blog} />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
};

export default MyBlogs;
